import { ISumData } from '../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { ekanalys_ekanalys_columns } from '../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import { TEDInputAvenyEKTimeInterval } from '../../../../../../../../globalQueryTypes';
import {
  DateInputType,
  getCurrentDateTimeFileName,
} from '../../../../../../../../Utils/dateUtils';
import { ISortProperty } from '../../../../../../../../BaseComponents/Table/Components/SortableTableUtils';

export interface IExcelData {
  analys?: {
    name: string;
    rubrik: string | undefined;
    kategori: string | undefined;
    columns: ekanalys_ekanalys_columns[];
    sums: ISumData[];
    endast_bokfort: boolean;
    force_helarsjamforelse: boolean | null;
  };
  kodbeh_id: string;
  grundurval_id?: string;
  analysid: string;
  anvurval_selection: string | undefined;
  detaljurval_selection: string | undefined;
  force_helarsjamforelse: boolean | null;
  sumniva: number;
  budget_summerings_mode: 0 | 1;
  visanoll: boolean;
  delakodben: boolean;
  tidsintervall: TEDInputAvenyEKTimeInterval;
  visadetaljer: boolean;
  detaljkolumn: number;
  summerings_mode: 0 | 1 | 2;
  base: number;
  decimaler: number;
  periodType: PeriodType;
  jamforelsetal: string;
  fromPerString: string;
  tomPerString: string | null;
  periodLast: boolean;
}

type PeriodType = 'year' | 'yearMonth' | 'yearMonthDay';

export const getPeriodTypeFromDateInputType = (
  dateInputType: DateInputType
): PeriodType => {
  switch (dateInputType) {
    case DateInputType.year:
      return 'year';
    case DateInputType.yearMonth:
      return 'yearMonth';
    case DateInputType.yearMonthDay:
      return 'yearMonthDay';
  }
};

interface IExcelGenericData {
  db: string;
  collectionName: string;
  fields: string;
  selection?: string;
  selection_id?: string;
  sortProperties: ISortProperty[];
}

export const ExcelQuery = (
  data: IExcelData | IExcelGenericData,
  name: string,
  backendUrl: string,
  reportName: string,
  setLoading: (loading: boolean) => void
) => {
  if ('download' in HTMLAnchorElement.prototype) {
    setLoading(true);
    fetch(`${backendUrl}/excel?reportName=${reportName}`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(data),
    }).then(response => {
      if (!response.ok) {
        return;
      }
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        // For internet explorer
        const nav = navigator as unknown as { msSaveBlob?: Function; msSaveOrOpenBlob?: Function };
        if (nav.msSaveBlob || nav.msSaveOrOpenBlob) {
          nav.msSaveOrOpenBlob?.(blob, `${name}.xlsx`);
        } else {
          const link = document.createElement('a');
          link.href = url;
          link.download = `${name} ${getCurrentDateTimeFileName()}.xlsx`;
          document.body.appendChild(link);
          link.click();
        }
        setLoading(false);
      });
    });
  } else {
    const fileNameWithDate = `${name} ${getCurrentDateTimeFileName()}.xlsx`;

    const form = document.createElement('form');
    form.action = `${backendUrl}/excel?reportName=${reportName}`;
    form.method = 'post';
    form.target =
      'download' in HTMLAnchorElement.prototype ? '_self' : '_blank';

    const input = document.createElement('input');
    input.name = 'json';
    input.value = JSON.stringify({
      ...data,
      fileName: fileNameWithDate,
    });
    input.type = 'hidden';

    form.appendChild(input);
    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
  }
};
